<template>
  <div class="c15">
    <p class="c1">
 
      <span
        style="
          overflow: hidden;
          display: inline-block;
          margin: 0px 0px;
          border: 0px solid #000000;
          transform: rotate(0rad) translateZ(0px);
          -webkit-transform: rotate(0rad) translateZ(0px);
          width: 200.87px;
          height: 200.87px;
        "
        ><img
          alt=""
          src="@/assets/Rectangle.svg"
          style="
            width: 200.87px;
            height: 200.87px;
            margin-left: 0px;
            margin-top: 0px;
            transform: rotate(0rad) translateZ(0px);
            -webkit-transform: rotate(0rad) translateZ(0px);
          "
          title=""
      /></span>
    </p>
    <p class="c1">
      <span class="c13">&nbsp;</span
      ><span class="c14"
        >{{ $t("PRIVACY POLICY") }} &ndash; {{ $t("PACTO APPLICATION") }}</span
      >
    </p>
    <h1 class="c1 c4" id="h.s6avdzeuph8q">
      <span class="c7">{{ $t("1. INTRODUCTION") }}</span>
    </h1>
    <p class="c1">
      <span class="c2">{{
        $t(
            "Thanks message for using Pacto App"
        )
      }}</span>
    </p>
    <p class="c1">
      <span class="c2"
        >{{$t(
          'The Safe Nights Rest application is a product of the Norwegian Refugee Council. Organisation is an independent humanitarian organisation working to protect the rights of displaced and vulnerable people during crisis. One of the core values of Organisation is Accountability; Organisation is committed to being accountable to our staff and the people we serve.'
          )}}</span
      >
    </p>
    <h2 class="c1 c4" id="h.w3j4jiui7m8c">
      <span class="c5">{{$t('1.1. Data Controller')}}</span>
    </h2>
    <p class="c1">
      <span class="c2"
        >{{$t(
          'Privacy Policy for Data Controller 1.1.1'
          )}}</span>
    </p>
    <p class="c1 c9">
      <span class="c2"
        >{{$t('Norwegian Refugee Council (&laquo;Data controller&raquo;)')}}</span
      >
    </p>
    <p class="c1 c9">
      <span class="c2">{{$t('VAT number 977 538 319, Prinsens gate 2, 0152 Oslo')}}</span>
    </p>
    <p class="c1">
      <span class="c2"
        >&nbsp;{{$t('Privacy Policy for Data Controller 1.1.4')}}</span
      >
    </p>
    <p class="c1">
      <span class="c2"
        >&nbsp;{{$t('Privacy Policy for Data Controller 1.1.5')}}</span>
    </p>
    <h1 class="c1 c4" id="h.36y65oqh6vsn">
      <span class="c7">{{$t('2. Information we collect')}}</span>
    </h1>
    <p class="c1">
      <span class="c2"
        >{{$t('There are 4 general categories of information that we collect.')}}</span
      >
    </p>
    <h2 class="c1 c4" id="h.2b83f6lm9n1y">
      <span class="c5"
        >{{$t('2.1. Information you give us that is necessary for the use of the pacto application.')}}</span
      >
    </h2>
    <p class="c1">
      <span class="c2"
        >{{$t('Privacy Policy for Information you give us that is necessary for the use of the pacto application 2.1.1')}}</span
      >
    </p>
    <ul class="c0 lst-kix_q5klg7mmrj8o-0 start">
      <li class="c1 c6">
        <span class="c2"
          >{{$t('Privacy Policy for Information you give us that is necessary for the use of the pacto application 2.1.2')}}</span
        >
      </li>
      <li class="c1 c6">
        <span class="c2"
          >{{$t('Privacy Policy for Information you give us that is necessary for the use of the pacto application 2.1.3')}}</span
        >
      </li>
      <li class="c1 c6">
        <span class="c2"
          >{{$t('Privacy Policy for Information you give us that is necessary for the use of the pacto application 2.1.4')}}</span
        >
      </li>
      <li class="c1 c6">
        <span class="c2"
          >{{$t('Privacy Policy for Information you give us that is necessary for the use of the pacto application 2.1.5')}}</span>
      </li>
      <li class="c1 c6">
        <span class="c2"
          >{{$t('Privacy Policy for Information you give us that is necessary for the use of the pacto application 2.1.6')}}</span
        >
      </li>
    </ul>
    <h2 class="c1 c4" id="h.bsif8y29qnuf">
      <span class="c5"
        >{{$t('2.2. Information you choose to give us that allows us to improve the pacto experience')}}</span
      >
    </h2>
    <p class="c1">
      <span class="c2"
        >{{$t('Privacy Policy for Information you choose to give us that allows us to improve the pacto experience 2.2.1')}}</span
      >
    </p>
    <ul class="c0 lst-kix_l3l0j2ddglvo-0 start">
      <li class="c1 c6">
        <span class="c2"
          >{{$t('Privacy Policy for Information you choose to give us that allows us to improve the pacto experience 2.2.2')}}</span
        >
      </li>
      <li class="c1 c6">
        <span class="c2"
          >{{$t('Privacy Policy for Information you choose to give us that allows us to improve the pacto experience 2.2.3')}}</span
        >
      </li>
    </ul>
    <h2 class="c1 c4" id="h.nmq8a5imal4u">
      <span class="c5"
        >{{$t('2.3. Information we automatically collect from your use of the pacto application.')}}</span
      >
    </h2>
    <p class="c1">
      <span class="c2"
        >{{$t('Privacy Policy for Information we automatically collect from your use of the pacto application 2.3.1')}}</span
      >
    </p>
    <ul class="c0 lst-kix_m4m2h68vnyuh-0 start">
      <li class="c1 c6">
        <span class="c2"
          >{{$t('Geolocation: we may collect geolocation data about your approximate location via GPS or IP address')}}</span
        >
      </li>
      <li class="c1 c6">
        <span class="c2"
          >{{$t('Privacy Policy for Information we automatically collect from your use of the pacto application 2.3.3')}}</span
        >
      </li>
      <li class="c1 c6">
        <span class="c2"
          >{{$t('Privacy Policy for Information we automatically collect from your use of the pacto application 2.3.4')}}</span
        >
      </li>
    </ul>
    <h2 class="c1 c4" id="h.9h013cgo3z7d">
      <span class="c5"
        >{{$t('2.4. Information we collect about you from third parties.')}}</span
      >
    </h2>
    <p class="c1">
      <span class="c2"
        >{{$t('Privacy Policy for Information we collect about you from third parties 2.4.1')}}</span
      >
    </p>
    <ul class="c0 lst-kix_mgfotgex9o4o-0 start">
      <li class="c1 c6">
        <span class="c2"
          >{{$t('Privacy Policy for Information we collect about you from third parties 2.4.2')}}</span
        >
      </li>
    </ul>
    <h2 class="c1 c4" id="h.o0fg1r4z9r2k">
      <span class="c5">{{$t('2.5. Children&rsquo;s data')}}</span>
    </h2>
    <p class="c1">
      <span class="c2"
        >{{$t('Privacy Policy for Children&rsquo;s data 2.5.1')}}</span
      >
    </p>
    <h1 class="c1 c4" id="h.7ww66mct986m">
      <span class="c7">{{$t('3. HOW Organisation USES THE INFORMATION WE COLLECT')}}</span>
    </h1>
    <p class="c1">
      <span class="c2"
        >{{$t('Organisation may collect, use, store and process your personal data to (1) provide, understand, improve and develop the services provided by and through PACTO application, (2) create and maintain a safe, secure and trusted environment for all users and (3) report on social impact to investors and/or institutional donors.')}}</span
      >
    </p>
    <h2 class="c1 c4" id="h.j3xh5hx030gf">
      <span class="c5"
        >{{$t('Privacy Policy for HOW Organisation USES THE INFORMATION WE COLLECT 3.1')}}</span
      >
    </h2>
    <ul class="c0 lst-kix_4kwv5o75cxnv-0 start">
      <li class="c1 c6">
        <span class="c2"
          >{{$t('Enable you to use and access the Safe Nights Rest application')}}</span
        >
      </li>
      <li class="c1 c6">
        <span class="c2"
          >{{$t('Enable you to communicate with other users of the application')}}</span
        >
      </li>
      <li class="c1 c6">
        <span class="c2"
          >{{$t('Privacy Policy for HOW Organisation USES THE INFORMATION WE COLLECT 3.1.3')}}</span
        >
      </li>
      <li class="c1 c6"><span class="c2">{{$t('Provide customers service')}}</span></li>
      <li class="c1 c6">
        <span class="c2">{{$t('Send you service or support messages')}}</span>
      </li>
      <li class="c1 c6">
        <span class="c2">{{$t('Enable the listing of a property to be leased')}}</span>
      </li>
      <li class="c1 c6">
        <span class="c2"
          >{{$t('Privacy Policy for HOW Organisation USES THE INFORMATION WE COLLECT 3.1.7')}}</span
        >
      </li>
      <li class="c1 c6">
        <span class="c2"
          >{{$t('Enable usage of e-signed agreements outside of the application')}}</span
        >
      </li>
    </ul>
    <p class="c1">
      <span class="c2"
        >{{$t('Privacy Policy for HOW Organisation USES THE INFORMATION WE COLLECT 3.1.9')}}</span
      >
    </p>
    <h2 class="c1 c4" id="h.p8brhtvez88c">
      <span class="c5"
        >{{$t('3.2. Create and maintain a safe, secure, and trusted environment for all Users.')}}</span
      >
    </h2>
    <ul class="c0 lst-kix_xod5q0hzxcvd-0 start">
      <li class="c1 c6">
        <span class="c2"
          >{{$t('To detect and prevent fraud, spam, abuse, security incidents and other harmful activity.')}}</span
        >
      </li>
      <li class="c1 c6">
        <span class="c2"
          >{{$t('Privacy Policy for Create and maintain a safe, secure, and trusted environment for all Users 2')}}</span
        >
      </li>
      <li class="c1 c6">
        <span class="c2">{{$t('Comply with our legal obligations')}}</span>
      </li>
      <li class="c1 c6">
        <span class="c2"
          >{{$t('Resolve any disputes with any of our Users and enforce our agreements with third parties')}}</span
        >
      </li>
      <li class="c1 c6">
        <span class="c2">{{$t('Enforce our Terms of Service and other policies')}}</span>
      </li>
    </ul>
    <p class="c1">
      <span class="c2"
        >{{$t('Privacy Policy for Create and maintain a safe, secure, and trusted environment for all Users 6')}}</span
      >
    </p>
    <p class="c1">
      <span class="c2"
        >{{$t('Privacy Policy for Create and maintain a safe, secure, and trusted environment for all Users 7')}}</span
      >
    </p>
    <h2 class="c1 c4" id="h.ncp8sdib7eru">
      <span class="c5"
        >{{$t('3.3. Measure and report on social impact outcomes such that')}}</span
      >
    </h2>
    <ul class="c0 lst-kix_9mghw7k5etl-0 start">
      <li class="c1 c6">
        <span class="c2"
          >{{$t('Privacy policy for Measure and report on social impact outcomes such that 1')}}</span
        >
      </li>
      <li class="c1 c6">
        <span class="c2"
          >{{$t('Privacy policy for Measure and report on social impact outcomes such that 2')}}</span
        >
      </li>
    </ul>
    <h1 class="c1 c4" id="h.gqo7ggtpln1q">
      <span class="c7">{{$t('4. SHARING AND DISCLOSURE')}}</span>
    </h1>
    <h2 class="c1 c4" id="h.dp13mec6ymt">
      <span class="c5">{{$t('4.1. Sharing between users')}}</span>
    </h2>
    <p class="c1">
      <span class="c2"
        >{{$t('Privacy policy for Sharing between users 1')}}</span
      >
    </p>
    <ul class="c0 lst-kix_l02k23gi25pu-0 start">
      <li class="c1 c6">
        <span class="c2"
          >{{$t('Privacy policy for Sharing between users 2')}}</span
        >
      </li>
      <li class="c1 c6">
        <span class="c2"
          >{{$t('Privacy policy for Sharing between users 3')}}</span
        >
      </li>
      <li class="c1 c6">
        <span class="c2"
          >{{$t('Privacy policy for Sharing between users 4')}}</span
        >
      </li>
    </ul>
    <h2 class="c1 c4" id="h.8slawf9dvvez">
      <span class="c5"
        >{{$t('4.2. Compliance with law, responding to legal requests, preventing harm and protection of our rights.')}}</span
      >
    </h2>
    <ul class="c0 lst-kix_4rggbr1cbnyr-0 start">
      <li class="c1 c6">
        <span class="c2"
          >{{$t('Privacy policy of Compliance with law, responding to legal requests, preventing harm and protection of our rights 1')}}</span
        >
      </li>
      <li class="c1 c6">
        <span class="c2"
          >{{$t('Privacy policy of Compliance with law, responding to legal requests, preventing harm and protection of our rights 2')}}</span
        >
      </li>
      <li class="c1 c6">
        <span class="c2"
          >{{$t('Privacy policy of Compliance with law, responding to legal requests, preventing harm and protection of our rights 3')}}</span
        >
      </li>
    </ul>
    <h2 class="c1 c4" id="h.sghoq1gfc0md">
      <span class="c5">{{$t('4.3. Service Providers')}}</span>
    </h2>
    <p class="c1">
      <span class="c2"
        >{{$t('Privacy policy of Service Providers 1')}}</span
      >
    </p>
    <p class="c1">
      <span class="c2"
        >&nbsp;{{$t('Privacy policy of Service Providers 2')}}</span
      >
    </p>
    <h2 class="c1 c4" id="h.e7pmhwfleet9">
      <span class="c5">{{$t('4.4. Referrals to other Service providers')}}</span>
    </h2>
    <p class="c1">
      <span class="c2"
        >{{$t('Privacy policy of Referrals to other Service providers')}}</span
      >
    </p>
    <h2 class="c1 c4" id="h.4s6z7xj16onb">
      <span class="c5">{{$t('4.5. Business Transfers')}}</span>
    </h2>
    <p class="c1">
      <span class="c2"
        >{{$t('Privacy policy of Business Transfers')}}</span
      >
    </p>
    <h2 class="c1 c4" id="h.z57jx074xm8u">
      <span class="c5">{{$t('4.6. Aggregated data.')}}</span>
    </h2>
    <p class="c1">
      <span class="c2"
        >{{$t('Privacy policy of Aggregated data')}}</span
      >
    </p>
    <h1 class="c1 c4" id="h.hxvdtizh0qh1">
      <span class="c7">{{$t('5. Other important information')}}</span>
    </h1>
    <h2 class="c1 c4" id="h.kggwes6v9t8d">
      <span class="c5">{{$t('5.1. Analyzing your communications.')}}</span>
    </h2>
    <p class="c1">
      <span class="c2"
        >{{$t('Privacy policy of Analyzing your communications 1')}}</span
      >
    </p>
    <p class="c1">
      <span class="c2"
        >{{$t('Privacy policy of Analyzing your communications 2')}}</span
      >
    </p>
    <h1 class="c1 c4" id="h.mkh81lj22x8k">
      <span class="c7">{{$t('6. YOUR RIGHTS')}}</span>
    </h1>
    <h2 class="c1 c4" id="h.64twxehxkggb">
      <span class="c5">{{$t('6.1. Managing your information')}}</span>
    </h2>
    <p class="c1">
      <span class="c2"
        >{{$t('User right to update and maintain the data')}}</span
      >
    </p>
    <h2 class="c1 c4" id="h.kg4jpjq15vdg">
      <span class="c5"
        >{{$t('6.2. Right to request changes to personal information')}}</span
      >
    </h2>
    <p class="c1">
      <span class="c2"
        >{{$t('Right to request an updation of the data')}}</span
      >
    </p>
    <h2 class="c1 c4" id="h.jrl0f3xr1s1n">
      <span class="c5">{{$t('6.3. Your rights to access')}}</span>
    </h2>
    <p class="c1">
      <span class="c2"
        >{{$t('Right to request access of the data')}}</span
      >
    </p>
    <h2 class="c1 c4" id="h.pcfogif3ksmw">
      <span class="c5">{{$t('6.4. Data retention and erasure.')}}</span>
    </h2>
    <p class="c1">
      <span class="c2"
        >{{$t('Retaining the user data until contract expires')}}</span
      >
    </p>
    <ul class="c0 lst-kix_bedya2rhf0x1-0 start">
      <li class="c1 c6">
        <span class="c2"
          >{{$t('retaining user data for legitimate business')}}</span
        >
      </li>
      <li class="c1 c6">
        <span class="c2"
          >{{$t('Legal obligations of user data')}}</span
        >
      </li>
      <li class="c1 c6">
        <span class="c2"
          >{{$t('Data users shared through the application details')}}</span
        >
      </li>
      <li class="c1 c6">
        <span class="c2"
          >{{$t('User data backup')}}</span
        >
      </li>
      <li class="c1 c6">
        <span class="c2"
          >{{$t('Data deletion of inactive users')}}</span
        >
      </li>
    </ul>
    <h2 class="c1 c4" id="h.ny9xda91ir45">
      <span class="c5"
        >{{$t('6.5. Retention and erasure of data by third party service providers.')}}</span
      >
    </h2>
    <p class="c1">
      <span class="c2"
        >{{$t('Rights of the user to delete thier data')}}</span
      >
    </p>
    <ul class="c0 lst-kix_ugipqntlnkiw-0 start">
      <li class="c1 c6">
        <span class="c2"
          >{{$t('Rights of the user signed agreements')}}</span
        >
      </li>
    </ul>
    <h2 class="c1 c4" id="h.gjqr9cmaoptq">
      <span class="c5">{{$t('6.6. Objection to processing')}}</span>
    </h2>
    <p class="c1">
      <span class="c2"
        >{{$t('Privacy policy of objection to processing of the data')}}</span
      >
    </p>
    <p class="c1">
      <span class="c2"
        >{{$t('Privacy policy of objection to processing of the consent')}}</span
      >
    </p>
    <h2 class="c1 c4" id="h.hhnwrsbccyu7">
      <span class="c5">{{$t('6.7. Lodging complaints')}}</span>
    </h2>
    <p class="c1">
      <span class="c2"
        >{{$t('Privacy policy of lodging complaints against the data processing')}}</span
      >
    </p>
    <p class="c1">
      <span class="c2"
        >{{$t('Privacy policy of lodging complaints against the authority')}}</span
      >
    </p>
    <p class="c1 c10">
      <span class="c2"
        >https://www.datatilsynet.no/rettigheter-og-plikter/den-registrertes-rettigheter/</span
      >
    </p>
    <h1 class="c1 c4" id="h.tcgbutysg0pn">
      <span class="c7">{{$t('7. SECURITY')}}</span>
    </h1>
    <p class="c1">
      <span class="c2"
        >{{$t('Privacy policy for security')}}</span
      >
    </p>
    <h1 class="c1 c4" id="h.3y0yx87p6018">
      <span class="c7">{{$t('8. CHANGES TO THIS PRIVACY POLICY')}}</span>
    </h1>
    <p class="c1">
      <span class="c2"
        >{{$t('message of change in privacy policy')}}</span
      >
    </p>
    <h1 class="c4 c11" id="h.a3crkqhwb0eu">
      <span class="c7">{{$t('9. CONTACT US')}}</span>
    </h1>
    <p class="c1">
      <span class="c2"
        >{{$t('Privacy policy of data processing')}}
      </span>
    </p>
    <p class="c1 c8"><span class="c2">data.protection@nrc.no</span></p>
    <p class="c1"><span class="c2">&nbsp;</span></p>
    <p class="c1"><span class="c2">&nbsp;</span></p>
    <p class="c12"><span class="c2"></span></p>
  </div>
</template>

<script>
export default {};
</script>

<style type="text/css" scoped>
@import url("https://themes.googleusercontent.com/fonts/css?kit=dpiI8CyVsrzWsJLBFKehGpLhv3qFjX7dUn1mYxfCXhI");

.lst-kix_l3l0j2ddglvo-0 > li:before {
  content: "\0025cf  ";
}

ul.lst-kix_9mghw7k5etl-0 {
  list-style-type: none;
}

ul.lst-kix_9mghw7k5etl-2 {
  list-style-type: none;
}

ul.lst-kix_9mghw7k5etl-1 {
  list-style-type: none;
}

.lst-kix_l3l0j2ddglvo-2 > li:before {
  content: "\0025a0  ";
}

.lst-kix_l3l0j2ddglvo-1 > li:before {
  content: "\0025cb  ";
}

.lst-kix_l3l0j2ddglvo-4 > li:before {
  content: "\0025cb  ";
}

ul.lst-kix_9mghw7k5etl-8 {
  list-style-type: none;
}

ul.lst-kix_9mghw7k5etl-7 {
  list-style-type: none;
}

ul.lst-kix_9mghw7k5etl-4 {
  list-style-type: none;
}

ul.lst-kix_9mghw7k5etl-3 {
  list-style-type: none;
}

.lst-kix_l3l0j2ddglvo-3 > li:before {
  content: "\0025cf  ";
}

ul.lst-kix_9mghw7k5etl-6 {
  list-style-type: none;
}

ul.lst-kix_9mghw7k5etl-5 {
  list-style-type: none;
}

.lst-kix_l3l0j2ddglvo-8 > li:before {
  content: "\0025a0  ";
}

.lst-kix_q5klg7mmrj8o-7 > li:before {
  content: "\0025cb  ";
}

.lst-kix_q5klg7mmrj8o-8 > li:before {
  content: "\0025a0  ";
}

.lst-kix_l3l0j2ddglvo-6 > li:before {
  content: "\0025cf  ";
}

.lst-kix_l3l0j2ddglvo-5 > li:before {
  content: "\0025a0  ";
}

.lst-kix_q5klg7mmrj8o-4 > li:before {
  content: "\0025cb  ";
}

.lst-kix_q5klg7mmrj8o-5 > li:before {
  content: "\0025a0  ";
}

.lst-kix_q5klg7mmrj8o-6 > li:before {
  content: "\0025cf  ";
}

.lst-kix_l3l0j2ddglvo-7 > li:before {
  content: "\0025cb  ";
}

.lst-kix_q5klg7mmrj8o-0 > li:before {
  content: "\0025cf  ";
}

.lst-kix_q5klg7mmrj8o-3 > li:before {
  content: "\0025cf  ";
}

.lst-kix_q5klg7mmrj8o-1 > li:before {
  content: "\0025cb  ";
}

.lst-kix_q5klg7mmrj8o-2 > li:before {
  content: "\0025a0  ";
}

ul.lst-kix_4rggbr1cbnyr-8 {
  list-style-type: none;
}

ul.lst-kix_4rggbr1cbnyr-6 {
  list-style-type: none;
}

ul.lst-kix_4rggbr1cbnyr-7 {
  list-style-type: none;
}

ul.lst-kix_4rggbr1cbnyr-4 {
  list-style-type: none;
}

ul.lst-kix_4rggbr1cbnyr-5 {
  list-style-type: none;
}

ul.lst-kix_4rggbr1cbnyr-2 {
  list-style-type: none;
}

ul.lst-kix_4rggbr1cbnyr-3 {
  list-style-type: none;
}

ul.lst-kix_4rggbr1cbnyr-0 {
  list-style-type: none;
}

ul.lst-kix_4rggbr1cbnyr-1 {
  list-style-type: none;
}

ul.lst-kix_m4m2h68vnyuh-1 {
  list-style-type: none;
}

ul.lst-kix_m4m2h68vnyuh-2 {
  list-style-type: none;
}

ul.lst-kix_m4m2h68vnyuh-0 {
  list-style-type: none;
}

.lst-kix_bedya2rhf0x1-0 > li:before {
  content: "\0025cf  ";
}

.lst-kix_bedya2rhf0x1-2 > li:before {
  content: "\0025a0  ";
}

ul.lst-kix_m4m2h68vnyuh-7 {
  list-style-type: none;
}

ul.lst-kix_m4m2h68vnyuh-8 {
  list-style-type: none;
}

ul.lst-kix_m4m2h68vnyuh-5 {
  list-style-type: none;
}

ul.lst-kix_m4m2h68vnyuh-6 {
  list-style-type: none;
}

ul.lst-kix_m4m2h68vnyuh-3 {
  list-style-type: none;
}

ul.lst-kix_m4m2h68vnyuh-4 {
  list-style-type: none;
}

.lst-kix_ugipqntlnkiw-7 > li:before {
  content: "\0025cb  ";
}

.lst-kix_xod5q0hzxcvd-0 > li:before {
  content: "\0025cf  ";
}

.lst-kix_xod5q0hzxcvd-4 > li:before {
  content: "\0025cb  ";
}

.lst-kix_xod5q0hzxcvd-2 > li:before {
  content: "\0025a0  ";
}

.lst-kix_xod5q0hzxcvd-6 > li:before {
  content: "\0025cf  ";
}

.lst-kix_ugipqntlnkiw-5 > li:before {
  content: "\0025a0  ";
}

.lst-kix_xod5q0hzxcvd-8 > li:before {
  content: "\0025a0  ";
}

.lst-kix_ugipqntlnkiw-1 > li:before {
  content: "\0025cb  ";
}

.lst-kix_ugipqntlnkiw-3 > li:before {
  content: "\0025cf  ";
}

ul.lst-kix_4kwv5o75cxnv-7 {
  list-style-type: none;
}

ul.lst-kix_4kwv5o75cxnv-6 {
  list-style-type: none;
}

ul.lst-kix_4kwv5o75cxnv-8 {
  list-style-type: none;
}

ul.lst-kix_l02k23gi25pu-8 {
  list-style-type: none;
}

.lst-kix_mgfotgex9o4o-2 > li:before {
  content: "\0025a0  ";
}

ul.lst-kix_l02k23gi25pu-7 {
  list-style-type: none;
}

ul.lst-kix_l02k23gi25pu-6 {
  list-style-type: none;
}

ul.lst-kix_4kwv5o75cxnv-1 {
  list-style-type: none;
}

ul.lst-kix_l02k23gi25pu-5 {
  list-style-type: none;
}

ul.lst-kix_4kwv5o75cxnv-0 {
  list-style-type: none;
}

ul.lst-kix_l02k23gi25pu-4 {
  list-style-type: none;
}

ul.lst-kix_4kwv5o75cxnv-3 {
  list-style-type: none;
}

ul.lst-kix_l02k23gi25pu-3 {
  list-style-type: none;
}

ul.lst-kix_4kwv5o75cxnv-2 {
  list-style-type: none;
}

ul.lst-kix_l02k23gi25pu-2 {
  list-style-type: none;
}

ul.lst-kix_4kwv5o75cxnv-5 {
  list-style-type: none;
}

ul.lst-kix_l02k23gi25pu-1 {
  list-style-type: none;
}

ul.lst-kix_4kwv5o75cxnv-4 {
  list-style-type: none;
}

ul.lst-kix_l02k23gi25pu-0 {
  list-style-type: none;
}

.lst-kix_mgfotgex9o4o-0 > li:before {
  content: "\0025cf  ";
}

.lst-kix_4rggbr1cbnyr-7 > li:before {
  content: "\0025cb  ";
}

.lst-kix_4rggbr1cbnyr-5 > li:before {
  content: "\0025a0  ";
}

.lst-kix_bedya2rhf0x1-8 > li:before {
  content: "\0025a0  ";
}

.lst-kix_mgfotgex9o4o-4 > li:before {
  content: "\0025cb  ";
}

.lst-kix_4rggbr1cbnyr-1 > li:before {
  content: "\0025cb  ";
}

.lst-kix_bedya2rhf0x1-4 > li:before {
  content: "\0025cb  ";
}

.lst-kix_bedya2rhf0x1-6 > li:before {
  content: "\0025cf  ";
}

.lst-kix_4rggbr1cbnyr-3 > li:before {
  content: "\0025cf  ";
}

.lst-kix_mgfotgex9o4o-6 > li:before {
  content: "\0025cf  ";
}

.lst-kix_mgfotgex9o4o-8 > li:before {
  content: "\0025a0  ";
}

ul.lst-kix_q5klg7mmrj8o-0 {
  list-style-type: none;
}

.lst-kix_9mghw7k5etl-5 > li:before {
  content: "\0025a0  ";
}

.lst-kix_9mghw7k5etl-6 > li:before {
  content: "\0025cf  ";
}

ul.lst-kix_q5klg7mmrj8o-4 {
  list-style-type: none;
}

ul.lst-kix_q5klg7mmrj8o-3 {
  list-style-type: none;
}

.lst-kix_9mghw7k5etl-4 > li:before {
  content: "\0025cb  ";
}

.lst-kix_9mghw7k5etl-8 > li:before {
  content: "\0025a0  ";
}

ul.lst-kix_q5klg7mmrj8o-2 {
  list-style-type: none;
}

ul.lst-kix_q5klg7mmrj8o-1 {
  list-style-type: none;
}

ul.lst-kix_q5klg7mmrj8o-8 {
  list-style-type: none;
}

ul.lst-kix_q5klg7mmrj8o-7 {
  list-style-type: none;
}

.lst-kix_9mghw7k5etl-1 > li:before {
  content: "\0025cb  ";
}

.lst-kix_9mghw7k5etl-2 > li:before {
  content: "\0025a0  ";
}

ul.lst-kix_q5klg7mmrj8o-6 {
  list-style-type: none;
}

ul.lst-kix_q5klg7mmrj8o-5 {
  list-style-type: none;
}

.lst-kix_9mghw7k5etl-3 > li:before {
  content: "\0025cf  ";
}

ul.lst-kix_ugipqntlnkiw-6 {
  list-style-type: none;
}

ul.lst-kix_ugipqntlnkiw-7 {
  list-style-type: none;
}

ul.lst-kix_ugipqntlnkiw-4 {
  list-style-type: none;
}

ul.lst-kix_ugipqntlnkiw-5 {
  list-style-type: none;
}

.lst-kix_m4m2h68vnyuh-0 > li:before {
  content: "\0025cf  ";
}

ul.lst-kix_ugipqntlnkiw-2 {
  list-style-type: none;
}

ul.lst-kix_ugipqntlnkiw-3 {
  list-style-type: none;
}

.lst-kix_9mghw7k5etl-7 > li:before {
  content: "\0025cb  ";
}

ul.lst-kix_ugipqntlnkiw-0 {
  list-style-type: none;
}

ul.lst-kix_ugipqntlnkiw-1 {
  list-style-type: none;
}

.lst-kix_4kwv5o75cxnv-4 > li:before {
  content: "\0025cb  ";
}

ul.lst-kix_ugipqntlnkiw-8 {
  list-style-type: none;
}

.lst-kix_4kwv5o75cxnv-3 > li:before {
  content: "\0025cf  ";
}

.lst-kix_4kwv5o75cxnv-0 > li:before {
  content: "\0025cf  ";
}

.lst-kix_4kwv5o75cxnv-2 > li:before {
  content: "\0025a0  ";
}

.lst-kix_4kwv5o75cxnv-1 > li:before {
  content: "\0025cb  ";
}

.lst-kix_9mghw7k5etl-0 > li:before {
  content: "\0025cf  ";
}

.lst-kix_l02k23gi25pu-0 > li:before {
  content: "\0025cf  ";
}

.lst-kix_l02k23gi25pu-1 > li:before {
  content: "\0025cb  ";
}

.lst-kix_l02k23gi25pu-8 > li:before {
  content: "\0025a0  ";
}

.lst-kix_4kwv5o75cxnv-5 > li:before {
  content: "\0025a0  ";
}

.lst-kix_4kwv5o75cxnv-6 > li:before {
  content: "\0025cf  ";
}

.lst-kix_m4m2h68vnyuh-4 > li:before {
  content: "\0025cb  ";
}

.lst-kix_m4m2h68vnyuh-6 > li:before {
  content: "\0025cf  ";
}

.lst-kix_4kwv5o75cxnv-7 > li:before {
  content: "\0025cb  ";
}

.lst-kix_m4m2h68vnyuh-1 > li:before {
  content: "\0025cb  ";
}

.lst-kix_m4m2h68vnyuh-5 > li:before {
  content: "\0025a0  ";
}

.lst-kix_4kwv5o75cxnv-8 > li:before {
  content: "\0025a0  ";
}

.lst-kix_m4m2h68vnyuh-2 > li:before {
  content: "\0025a0  ";
}

.lst-kix_l02k23gi25pu-7 > li:before {
  content: "\0025cb  ";
}

.lst-kix_m4m2h68vnyuh-3 > li:before {
  content: "\0025cf  ";
}

.lst-kix_l02k23gi25pu-6 > li:before {
  content: "\0025cf  ";
}

.lst-kix_l02k23gi25pu-4 > li:before {
  content: "\0025cb  ";
}

.lst-kix_l02k23gi25pu-5 > li:before {
  content: "\0025a0  ";
}

.lst-kix_l02k23gi25pu-2 > li:before {
  content: "\0025a0  ";
}

.lst-kix_m4m2h68vnyuh-8 > li:before {
  content: "\0025a0  ";
}

.lst-kix_l02k23gi25pu-3 > li:before {
  content: "\0025cf  ";
}

.lst-kix_m4m2h68vnyuh-7 > li:before {
  content: "\0025cb  ";
}

.lst-kix_bedya2rhf0x1-1 > li:before {
  content: "\0025cb  ";
}

.lst-kix_ugipqntlnkiw-6 > li:before {
  content: "\0025cf  ";
}

ul.lst-kix_xod5q0hzxcvd-5 {
  list-style-type: none;
}

ul.lst-kix_xod5q0hzxcvd-6 {
  list-style-type: none;
}

ul.lst-kix_xod5q0hzxcvd-3 {
  list-style-type: none;
}

ul.lst-kix_xod5q0hzxcvd-4 {
  list-style-type: none;
}

ul.lst-kix_xod5q0hzxcvd-1 {
  list-style-type: none;
}

ul.lst-kix_xod5q0hzxcvd-2 {
  list-style-type: none;
}

.lst-kix_ugipqntlnkiw-8 > li:before {
  content: "\0025a0  ";
}

ul.lst-kix_xod5q0hzxcvd-0 {
  list-style-type: none;
}

ul.lst-kix_mgfotgex9o4o-3 {
  list-style-type: none;
}

ul.lst-kix_mgfotgex9o4o-4 {
  list-style-type: none;
}

ul.lst-kix_mgfotgex9o4o-5 {
  list-style-type: none;
}

ul.lst-kix_mgfotgex9o4o-6 {
  list-style-type: none;
}

ul.lst-kix_mgfotgex9o4o-0 {
  list-style-type: none;
}

ul.lst-kix_mgfotgex9o4o-1 {
  list-style-type: none;
}

.lst-kix_xod5q0hzxcvd-1 > li:before {
  content: "\0025cb  ";
}

ul.lst-kix_xod5q0hzxcvd-7 {
  list-style-type: none;
}

ul.lst-kix_mgfotgex9o4o-2 {
  list-style-type: none;
}

ul.lst-kix_xod5q0hzxcvd-8 {
  list-style-type: none;
}

.lst-kix_xod5q0hzxcvd-3 > li:before {
  content: "\0025cf  ";
}

.lst-kix_xod5q0hzxcvd-7 > li:before {
  content: "\0025cb  ";
}

.lst-kix_ugipqntlnkiw-0 > li:before {
  content: "\0025cf  ";
}

.lst-kix_xod5q0hzxcvd-5 > li:before {
  content: "\0025a0  ";
}

.lst-kix_ugipqntlnkiw-4 > li:before {
  content: "\0025cb  ";
}

.lst-kix_ugipqntlnkiw-2 > li:before {
  content: "\0025a0  ";
}

ul.lst-kix_l3l0j2ddglvo-6 {
  list-style-type: none;
}

ul.lst-kix_l3l0j2ddglvo-7 {
  list-style-type: none;
}

ul.lst-kix_l3l0j2ddglvo-4 {
  list-style-type: none;
}

ul.lst-kix_l3l0j2ddglvo-5 {
  list-style-type: none;
}

ul.lst-kix_l3l0j2ddglvo-2 {
  list-style-type: none;
}

ul.lst-kix_l3l0j2ddglvo-3 {
  list-style-type: none;
}

ul.lst-kix_l3l0j2ddglvo-0 {
  list-style-type: none;
}

ul.lst-kix_l3l0j2ddglvo-1 {
  list-style-type: none;
}

ul.lst-kix_l3l0j2ddglvo-8 {
  list-style-type: none;
}

.lst-kix_mgfotgex9o4o-1 > li:before {
  content: "\0025cb  ";
}

.lst-kix_mgfotgex9o4o-3 > li:before {
  content: "\0025cf  ";
}

ul.lst-kix_bedya2rhf0x1-8 {
  list-style-type: none;
}

ul.lst-kix_bedya2rhf0x1-7 {
  list-style-type: none;
}

ul.lst-kix_bedya2rhf0x1-6 {
  list-style-type: none;
}

ul.lst-kix_bedya2rhf0x1-5 {
  list-style-type: none;
}

ul.lst-kix_bedya2rhf0x1-4 {
  list-style-type: none;
}

ul.lst-kix_bedya2rhf0x1-3 {
  list-style-type: none;
}

ul.lst-kix_bedya2rhf0x1-2 {
  list-style-type: none;
}

ul.lst-kix_bedya2rhf0x1-1 {
  list-style-type: none;
}

ul.lst-kix_bedya2rhf0x1-0 {
  list-style-type: none;
}

ul.lst-kix_mgfotgex9o4o-7 {
  list-style-type: none;
}

ul.lst-kix_mgfotgex9o4o-8 {
  list-style-type: none;
}

.lst-kix_4rggbr1cbnyr-8 > li:before {
  content: "\0025a0  ";
}

.lst-kix_mgfotgex9o4o-5 > li:before {
  content: "\0025a0  ";
}

.lst-kix_4rggbr1cbnyr-6 > li:before {
  content: "\0025cf  ";
}

.lst-kix_4rggbr1cbnyr-0 > li:before {
  content: "\0025cf  ";
}

.lst-kix_4rggbr1cbnyr-4 > li:before {
  content: "\0025cb  ";
}

.lst-kix_bedya2rhf0x1-3 > li:before {
  content: "\0025cf  ";
}

.lst-kix_bedya2rhf0x1-7 > li:before {
  content: "\0025cb  ";
}

.lst-kix_mgfotgex9o4o-7 > li:before {
  content: "\0025cb  ";
}

.lst-kix_4rggbr1cbnyr-2 > li:before {
  content: "\0025a0  ";
}

.lst-kix_bedya2rhf0x1-5 > li:before {
  content: "\0025a0  ";
}

ol {
  margin: 0;
  padding: 0;
}

table td,
table th {
  padding: 0;
}

.c3 {
  color: #ff7800;
  font-weight: 400;
  text-decoration: none;
  vertical-align: baseline;
  font-size: 11pt;
  font-family: "Roboto", sans-serif;
  font-style: normal;
}

.c7 {
  color: #000000;
  font-weight: 400;
  text-decoration: none;
  vertical-align: baseline;
  font-size: 20pt;
  font-family: "Roboto", sans-serif;
  font-style: normal;
}

.c12 {
  padding-top: 0pt;
  padding-bottom: 0pt;
  line-height: 1.15;
  orphans: 2;
  widows: 2;
  text-align: left;
  height: 11pt;
}

.c14 {
  color: #4A0A1E;
  font-weight: 700;
  text-decoration: none;
  vertical-align: baseline;
  font-size: 23pt;
  font-family: "Roboto", sans-serif;
  font-style: normal;
}

.c5 {
  color: #000000;
  font-weight: 400;
  text-decoration: none;
  vertical-align: baseline;
  font-size: 16pt;
  font-family: "Roboto", sans-serif;
  font-style: normal;
}

.c2 {
  color: #000000;
  font-weight: 400;
  text-decoration: none;
  vertical-align: baseline;
  font-size: 11pt;
  font-family: "Roboto", sans-serif;
  font-style: normal;
}

.c1 {
  padding-top: 12pt;
  padding-bottom: 12pt;
  line-height: 1.15;
  orphans: 2;
  widows: 2;
  text-align: left;
}

.c11 {
  padding-top: 20pt;
  padding-bottom: 6pt;
  line-height: 1.15;
  orphans: 2;
  widows: 2;
  text-align: left;
}

.c13 {
  font-family: "Roboto", sans-serif;
  color: #ff7800;
  font-weight: 400;
}

.c15 {
  background-color: #ffffff;
  width: 100%;
  padding: 72pt 72pt 72pt 72pt;
}

.c6 {
  margin-left: 36pt;
  padding-left: 0pt;
}

.c0 {
  padding: 0;
  margin: 0;
}

.c8 {
  margin-left: 36pt;
  text-indent: 36pt;
}

.c9 {
  margin-left: 36pt;
}

.c4 {
  page-break-after: avoid;
}

.c10 {
  text-indent: 36pt;
}

.title {
  padding-top: 0pt;
  color: #000000;
  font-size: 26pt;
  padding-bottom: 3pt;
  font-family: "Arial", sans-serif;
  line-height: 1.15;
  page-break-after: avoid;
  orphans: 2;
  widows: 2;
  text-align: left;
}

.subtitle {
  padding-top: 0pt;
  color: #666666;
  font-size: 15pt;
  padding-bottom: 16pt;
  font-family: "Arial", sans-serif;
  line-height: 1.15;
  page-break-after: avoid;
  orphans: 2;
  widows: 2;
  text-align: left;
}

li {
  color: #000000;
  font-size: 11pt;
  font-family: "Arial", sans-serif;
}

p {
  margin: 0;
  color: #000000;
  font-size: 11pt;
  font-family: "Arial", sans-serif;
}

h1 {
  padding-top: 20pt;
  color: #000000;
  font-size: 20pt;
  padding-bottom: 6pt;
  font-family: "Arial", sans-serif;
  line-height: 1.15;
  page-break-after: avoid;
  orphans: 2;
  widows: 2;
  text-align: left;
}

h2 {
  padding-top: 18pt;
  color: #000000;
  font-size: 16pt;
  padding-bottom: 6pt;
  font-family: "Arial", sans-serif;
  line-height: 1.15;
  page-break-after: avoid;
  orphans: 2;
  widows: 2;
  text-align: left;
}

h3 {
  padding-top: 16pt;
  color: #434343;
  font-size: 14pt;
  padding-bottom: 4pt;
  font-family: "Arial", sans-serif;
  line-height: 1.15;
  page-break-after: avoid;
  orphans: 2;
  widows: 2;
  text-align: left;
}

h4 {
  padding-top: 14pt;
  color: #666666;
  font-size: 12pt;
  padding-bottom: 4pt;
  font-family: "Arial", sans-serif;
  line-height: 1.15;
  page-break-after: avoid;
  orphans: 2;
  widows: 2;
  text-align: left;
}

h5 {
  padding-top: 12pt;
  color: #666666;
  font-size: 11pt;
  padding-bottom: 4pt;
  font-family: "Arial", sans-serif;
  line-height: 1.15;
  page-break-after: avoid;
  orphans: 2;
  widows: 2;
  text-align: left;
}

h6 {
  padding-top: 12pt;
  color: #666666;
  font-size: 11pt;
  padding-bottom: 4pt;
  font-family: "Arial", sans-serif;
  line-height: 1.15;
  page-break-after: avoid;
  font-style: italic;
  orphans: 2;
  widows: 2;
  text-align: left;
}
</style>